<template>
    <div class="page-homes">
        <CBNavbar @navbar-click="onNavbarClick" />
        <div class="page">
            <div class="pageContentOne">
                <div class="pageContentOne1">{{$t('value72')}}</div>
                <!-- <div class="pageContentOne2">{{$t('FLOWPrice')}}：${{datas.getFlowPrice}}</div> -->
                 <div class="pageContentOne2">{{$t('FLOWPrice')}}：$0.1</div>
            </div>
            <div class="pageContentTwo">
                <el-carousel  :autoplay="false" class="pageContentTwo1" @change="prevFn" arrow="always">
                    <el-carousel-item v-for="(item,index) in imgTwoList" :key="index">
                        <img :src="item.url" alt="background" class="background">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="pageContentThree">{{$t('value80')}}</div> 
            <div class="pageContentFour">1.{{$t('value53')}}{{imgTwoListData.OutputRatio}}%</div>
            <div class="pageContentFive">2.{{$t('value54')}} {{imgTwoListData.TotalTokenOutput}} {{langs=='zh_CN'?'枚':''}}</div>
            <div class="pageContentFour">3.{{$t('value55')}}</div>
            <div class="pageContentSix">4.{{$t('value77')}}</div>
            <!-- <div class="pageContentSeven">{{$t('value65')}}：1</div>
            <div class="pageContentEight">{{$t('value66')}}</div> -->
            <div class="pageContentNine">{{$t('value79')}}</div>
            <div class="pageContentTen">
                <div class="pageContentTen1">{{$t('value57')}}</div>
                <div class="pageContentTen2">{{datas.NFTlaimableEarnings&&datas.NFTlaimableEarnings!=='--'?datas.NFTlaimableEarnings.toFixed(2):Number(datas.NFTlaimableEarnings).toFixed(2)}} FLOW</div>
            </div>
            <div class="pageContentEleven66">
                <div>{{$t('value58')}}</div>
                <!-- <div>{{datas.historyReceived&&datas.historyReceived!=='--'&&datas.historyReceived!=='0'?datas.historyReceived.toFixed(2):Number(datas.historyReceived).toFixed(2)}} FLOW</div> -->
                 <div>{{datas.historyReceived&&datas.historyReceived!=='--'&&datas.historyReceived!=='0'?datas.historyReceived.toFixed(2):Number(datas.historyReceived).toFixed(2)}} FLOW</div>
            </div>
            <div class="pageContentTwelve66">
                <div>{{$t('value59')}}</div>
                <div>{{datas.lastHarverstTime!=='0'?timestampToTime(datas.lastHarverstTime):datas.TheTimeBeforeCollection!=='0'?timestampToTime(datas.TheTimeBeforeCollection):'--'}}</div>
            </div>
            <!-- <div class="pageContentSeven">{{$t('value65')}}：{{datas.NftAmount}}</div> -->
             <div class="pageContentSeven">{{$t('value65')}}：{{NftAmountZhi=='--'?datas.TheNumberOfLevelCards1:NftAmountZhi}}</div>
            <div class="pageContentEight" @click="drawer=true">{{$t('value61')}}</div>
            <!-- <div class="pageContentFourteen">
                <div class="pageContentFourteen1">{{$t('value60')}}</div>
                <div class="pageContentFourteen2" @click="drawer=true">{{$t('value61')}}</div>
            </div> -->
            <el-drawer
            :title="$t('value62')"
            :visible.sync="drawer"
            :direction="direction"
            size="45%">
                <div class="pageContentFifteen">
                    <div class="pageContentFifteen1">{{$t('value72')}}</div>
                    <div class="pageContentFifteen2">{{datas.NFTlaimableEarnings&&datas.NFTlaimableEarnings!=='--'?datas.NFTlaimableEarnings.toFixed(2):datas.NFTlaimableEarnings}} FLOW</div>
                </div>
                <div class="pageContentSixteen">
                    <div class="pageContentSixteen1">{{$t('value59')}}</div>
                    <div class="pageContentSixteen2">{{datas.lastHarverstTime!=='0'?timestampToTime(datas.lastHarverstTime):datas.TheTimeBeforeCollection!=='0'?timestampToTime(datas.TheTimeBeforeCollection):'--'}}</div>
                </div>
                <div class="pageContentSeventeen">
                    <div class="pageContentSeventeen1">{{$t('value63')}}</div>
                    <!-- <div class="pageContentSeventeen2">{{calculateTimeDifference(datas.lastHarverstTime)}}</div>  -->
                    <div class="pageContentSeventeen2">{{datas.TheHandlingFeeToBeDeducted!=='--'&&datas.TheHandlingFeeToBeDeducted!=='0'&&datas.TheHandlingFeeToBeDeducted&&datas.NFTlaimableEarnings&&datas.NFTlaimableEarnings!=='--'&&datas.NFTlaimableEarnings!=='0'?((0.2-datas.TheHandlingFeeToBeDeducted/datas.NFTlaimableEarnings)*100).toFixed(4):'0'}}%</div>
                </div>
                <div class="pageContentEighteen">
                    <div class="pageContentEighteen1">{{$t('value64')}}</div>
                    <!-- <div class="pageContentEighteen2">{{!datas.NFTlaimableEarnings&&datas.lastHarverstTime!=='0'?datas.NFTlaimableEarnings*(this.adjustedB/100):'--'}} FLOW</div> -->
                     <div class="pageContentEighteen2">{{datas.NFTlaimableEarnings&&datas.TheHandlingFeeToBeDeducted!=='--'&&datas.NFTlaimableEarnings!=='--'&&datas.TheHandlingFeeToBeDeducted?(datas.NFTlaimableEarnings-datas.TheHandlingFeeToBeDeducted).toFixed(2):'0.00'}} FLOW</div>
                </div>
                <div class="pageContentNineteen" @click="harvestFnClick">{{$t('value61')}}</div>
                <!-- <div class="pageContentNineteens">{{$t('value61')}}</div> -->
            </el-drawer>
        </div>
        <el-dialog
        :visible.sync="datas.dialogVisible"
        width="50%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="48vh">
        <span>{{$t('WaitForConfirmationOnTheChain')}}</span>
        </el-dialog>
    </div>
</template>

<script>
import CBNavbar from '@/components/navbar/indexTwo.vue'
import { mapState, mapGetters } from 'vuex'
import { Toast } from 'vant';
// import { MessageBox } from 'element-ui';
import './NFTPledge.css'
import { balanceOfFn, datas, getUserClaimStateFn, getFlowPriceInUSDTFn,harvestFn,calculateRewardsFn, tokenOfOwnerByLevelFn,ztai,setMyVariable,mintStartTimeFn } from "@/web3/index.js"
// import { balanceOfFn, datas, getUserClaimStateFn } from "@/web3/index.js"
import { locationHrefIndex } from '@/web3/index'
export default {
    name: 'NFTPledge',
    components: {
        CBNavbar,
    },
    data() {
        return {
          imgTwoList:[
            { 
                url: require('@/assets/images/card.png'),
                OutputRatio:'1.2',
                TotalTokenOutput:'1000',
            },
            { 
                url: require('@/assets/images/card2.png'),
                OutputRatio:'1.2',
                TotalTokenOutput:'4000', 
            },
            { 
                url: require('@/assets/images/card3.png'),
                OutputRatio:'1.3',
                TotalTokenOutput:'15000',
            },
            { 
                url: require('@/assets/images/card4.png'),
                OutputRatio:'1.4',
                TotalTokenOutput:'50000', 
            },
            { 
                url: require('@/assets/images/card5.png'),
                OutputRatio:'1.5',
                TotalTokenOutput:'200000', 
            },
          ],
          imgTwoListData: { 
                url: require('@/assets/images/card.png'),
                OutputRatio:'1.2',
                TotalTokenOutput:'1000',
          },
          drawer: false,
          direction: 'btt',
          datas,
          HandlingFee: 20,
          daysDiff: 0,
          adjustedB: 0,
          NftAmountZhi:datas.TheNumberOfLevelCards1,
          clears:null,
          Authorizationudgmentsstwo: 1,
          langs:'',
          offTimer:null,
        }
    },
    computed: {
        ...mapState(['address','lang']),
        ...mapGetters(['isLogin']),
    },
    methods: {
      harvestFnClick(){
        let that=this
        console.log('this.datas.NFTlaimableEarnings',this.datas.NFTlaimableEarnings);
        
        if(!this.datas.NFTlaimableEarnings||this.datas.NFTlaimableEarnings=='--'||this.datas.NFTlaimableEarnings=='0.00'){
            this.$message(this.$t('value78'))
            return
        }
        // Toast({
        //     message: this.$t('WaitForConfirmationOnTheChain'),
        //     duration:0,
        //     onClose: () => {
        //         that.$store.state.showOverlay=false
        //         that.showOverlay=false
        //     }
        // });
        that.datas.dialogVisible=true
        this.Authorizationudgmentsstwo=2
        harvestFn(this)
      },
      calculateTimeDifference(time) {
        datas.lastHarverstTime!=='0'?datas.lastHarverstTime:'--'
        if(!datas.lastHarverstTime||datas.lastHarverstTime=='0'){
            return "--"
        }
        // 获取当前时间
        const now = new Date();
        // 解析a的时间
        const dateA = new Date(time);
        
        // 计算时间差（毫秒）
        const timeDiff = now - dateA;
        // 转换为天数并向下取整
        this.daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        
        // 计算调整后的b值
        this.adjustedB = Math.max(5, this.HandlingFee - this.daysDiff);
        return `${this.adjustedB}%`
      },
      onNavbarClick(value) {
        console.log('Navbar clicked with value:', value); // 处理事件的方法，接收传递的值
        this.$router.push('/')
        // 在这里可以执行其他逻辑
      },
      prevFn(val,content){
        console.log('上一个',val,content);
        this.imgTwoListData=this.imgTwoList[val]
        // if(){
        //     NftAmountZhi
        // }
        switch(val) {
            case 0:
                // 代码块1
                this.NftAmountZhi=this.datas.TheNumberOfLevelCards1
                break;
            case 1:
                // 代码块2
                this.NftAmountZhi=this.datas.TheNumberOfLevelCards2
                break;
            case 2:
                // 代码块2
                this.NftAmountZhi=this.datas.TheNumberOfLevelCards3
                break;
            case 3:
                // 代码块2
                this.NftAmountZhi=this.datas.TheNumberOfLevelCards4
                break;
            case 4:
                // 代码块2
                this.NftAmountZhi=this.datas.TheNumberOfLevelCards5
                break;
            default:
                // 默认代码块
        }

        console.log('获取data',this.imgTwoListData);
      },
      upData(){
        setTimeout(()=>{
            console.log('打印地址')
            balanceOfFn(this)
            getUserClaimStateFn(this)
            getFlowPriceInUSDTFn()
            calculateRewardsFn(this)
            tokenOfOwnerByLevelFn(this)
            mintStartTimeFn()
        },1500)
      },
      timestampToTime(timestamp) {
        // 如果是秒级时间戳，转换成毫秒
        if (timestamp.toString().length === 10) {
            timestamp = timestamp * 1000;
        }
        const date = new Date(timestamp);

        // 格式化时间，补零函数
        const padZero = (num) => (num < 10 ? '0' + num : num);

        const year = date.getFullYear();
        const month = padZero(date.getMonth() + 1); // 月份从0开始
        const day = padZero(date.getDate());
        const hours = padZero(date.getHours());
        const minutes = padZero(date.getMinutes());
        const seconds = padZero(date.getSeconds());

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    },
    watch: {
        address(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.upData();
            }
        },
        lang(newVal, oldVal) {
            console.log('语言变化',newVal, oldVal);
            this.langs=newVal
        },
    },
    mounted(){
        let that=this
        this.langs=localStorage.getItem('language');
        this.upData()
        this.clears=setInterval(()=>{
            that.showOverlay=that.$store.state.showOverlay
            //监听交易是否完成
            ztai().then((res)=>{
                if (res) {
                    console.log(33);
                    if (that.Authorizationudgmentsstwo==2) {
                        that.Authorizationudgmentsstwo=1
                    }
                    Toast.clear();
                    that.datas.dialogVisible=false
                    this.upData()
                    that.drawer=false
                    let txHash=''
                    setMyVariable(txHash)
                }
            })
        },1000)
        this.offTimer=setInterval(async ()=>{
            let value=await locationHrefIndex()
            if(value){
            clearInterval(this.offTimer);  
            this.offTimer=null
            }
        },1000)
    },
    //离开页面时执行函数
    beforeDestroy() {         
        clearInterval(this.clears);  
        this.clears=null
        clearInterval(this.offTimer);  
        this.offTimer=null
    },
}
</script>
<style scoped lang="less">

</style>
